export default "__VITE_ASSET__243a3ad4__"